import { FC } from 'lib/component-utils'
import { useUserContext } from 'lib/context'
import { useAtomValue } from 'jotai'
import { bodyWidthAtom, sidebarIsLargeAtom } from 'components/sidebar/lib/atoms'
import WebauthnUpgradeBanner from 'components/auth/WebauthnUpgradeBanner'
import ChangelogNotifier from 'components/app/ChangelogNotifier'
import SurveyNotifier from 'components/app/SurveyNotifier'

const NotifiersContainer: FC = () => {
  const ctx = useUserContext()
  const sidebarIsLarge = useAtomValue(sidebarIsLargeAtom)
  const bodyWidth = useAtomValue(bodyWidthAtom)

  return (
    <div
      className="fixed bottom-6 flex flex-col gap-3 z-[1010] max-w-[26rem] max-sm:!left-4 max-sm:right-4 max-sm:bottom-4"
      style={{
        left: !sidebarIsLarge
          ? `calc((max(${bodyWidth}px, 1920px) - 1920px) / 2 + 4rem)`
          : `calc((max(${bodyWidth}px, 1920px) - 1920px) / 2 + 15rem)`,
      }}
    >
      {ctx?.isAuthorized && (
        <>
          <ChangelogNotifier />
          <SurveyNotifier />
        </>
      )}
      <WebauthnUpgradeBanner />
    </div>
  )
}

export default NotifiersContainer
